import { render, staticRenderFns } from "./InsolvencyPractitionerEscalationFile.vue?vue&type=template&id=17e174db&scoped=true&"
import script from "./InsolvencyPractitionerEscalationFile.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPractitionerEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPractitionerEscalationFile.vue?vue&type=style&index=0&id=17e174db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e174db",
  null
  
)

export default component.exports